import React from 'react'
import Pretype from './Pretype'
import './Pretype.css'

const Preloading = ({loading}) => {
  return (
    <>
      <div className={`preload-container ${loading ? 'show': 'hide'}`}>
        <div className="preload">
          <p className='preload-text'><Pretype/></p>
        </div>
      </div>
    </>
  )
}

export default Preloading
